
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0zm0 2.857C8.294 2.857 2.857 8.294 2.857 15S8.294 27.143 15 27.143 27.143 21.706 27.143 15 21.706 2.857 15 2.857zm.307 7.043c-.964 0-1.736-.814-1.736-1.779 0-.878.815-1.692 1.736-1.692.922 0 1.736.814 1.736 1.692 0 .943-.814 1.779-1.736 1.779zm0 12.814c-.943 0-1.543-.707-1.543-1.671v-8.314c0-.943.622-1.672 1.543-1.672.879 0 1.543.729 1.543 1.672v8.314c0 .943-.6 1.671-1.543 1.671z","fill":"#004B87"}})])
          )
        }
      }
    